import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import { AssetApi } from '../pages/Assets/models';

export interface AssetSelectorData extends AssetApi {
  typeDetails?: {
    id: string;
    name: string;
  };
  brandDetails?: {
    id: string;
    name: string;
  };
  modelDetails?: {
    id: string;
    name: string;
  };
}

interface AssetDisplayProps {
  selectedAsset: AssetSelectorData | null;
  onClear: () => void;
  onSearch: () => void;
  showDetails?: boolean;
  showWarning?: boolean;
  showButtons?: boolean;
}

const AssetDisplay = ({ 
  selectedAsset, 
  onClear, 
  onSearch, 
  showDetails = true,
  showWarning = true,
  showButtons = true
}: AssetDisplayProps) => {
  const getAssetDisplayText = (asset: AssetSelectorData) => {
    const type = asset.typeDetails?.name || asset.assetType?.name || '';
    const brand = asset.brandDetails?.name || asset.brand?.name || '';
    const model = asset.modelDetails?.name || asset.model?.name || '';
    return `${type} - ${brand} ${model}`.trim();
  };

  return (
    <>
      <div className='flex gap-4 relative items-center'>
        <input
          type='text'
          readOnly
          value={selectedAsset ? getAssetDisplayText(selectedAsset) : ''}
          placeholder='Busca un equipo'
          className={`input w-full pr-10 ${selectedAsset ? 'pr-10' : ''}`}
        />
        {showButtons && selectedAsset && (
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={onClear}
          >
            <ClearIcon color='inherit' className='text-[#FF7500]' />
          </GlobalButton>
        )}
        {showButtons && (
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={onSearch}
          >
            <SearchIcon color='inherit' className='text-white' />
          </GlobalButton>
        )}
      </div>

      {showDetails && selectedAsset && (
        <div className='flex flex-col gap-1 mt-2'>
          <div className='grid grid-cols-[max-content_1fr] gap-x-2 gap-y-1 items-center mb-5'>
            <strong>Equipo seleccionado: </strong>
            <span>{getAssetDisplayText(selectedAsset)}</span>
            <strong>Número de serie: </strong>
            <span>{selectedAsset.serialNumber || 'N/A'}</span>
            <strong>Condición: </strong>
            <span>{selectedAsset.condition || 'N/A'}</span>
          </div>
        </div>
      )}

      {showWarning && selectedAsset?.user && selectedAsset.user !== null && (
        <div className='mt-2 p-3 bg-orange-50 border border-orange-200 rounded-md'>
          <div className='flex items-center gap-2 text-orange-700'>
            <span className='text-lg'>⚠️</span>
            <div>
              <strong>Advertencia:</strong> Este equipo ya está asignado al
              usuario{' '}
              <span className='font-semibold'>
                {selectedAsset.user.fullName || 'Usuario desconocido'}
              </span>
            </div>
          </div>
          <p className='text-sm text-orange-600 mt-1'>
            Al crear esta asignación, el equipo será reasignado al nuevo
            usuario.
          </p>
        </div>
      )}
    </>
  );
};

export const getAssetDisplayText = (asset: any) => {
  if (!asset) return 'N/A';
  
  const type = asset.typeDetails?.name || asset.assetType?.name || asset.typeInfo?.name || asset.type?.name || 'N/A';
  const brand = asset.brandDetails?.name || asset.brand?.name || 'N/A';
  const model = asset.modelDetails?.name || asset.model?.name || 'N/A';
  
  return `${type} - ${brand} ${model}`;
};

export default AssetDisplay; 